module.exports = __webpack_public_path__ + "static/images/monet/left_panel_expand_icon.png";